<template>
  <div
    v-if="loading"
    id="myapp"
    style="height: 100%; width: 100%;"
  >
    <div class="loading">
      <div class="loader" />
    </div>
  </div>
  <div
    v-else
    id="myapp"
    style="height: 100%; width: 100%;"
  >
    <div style="height: 100%; width: 100%;">
      <vl-map
        v-if="showMap"
        ref="map"
        data-projection="EPSG:4326"
        style="height:1000px; width: 100%; "
      >
        <vl-view
          ref="view"
          :center.sync="center"
          :rotation.sync="rotation"
          :zoom.sync="zoom"
          ident="view"
          style="height: 100%; width: 100%;"
        />



        <vl-layer-tile>
          <vl-source-osm />
        </vl-layer-tile>

        <!-- <vl-layer-vector>
            <vl-source-vector url="https://openlayers.org/en/latest/examples/data/geojson/countries.geojson"></vl-source-vector>
          </vl-layer-vector> -->


        <vl-interaction-select
          :condition="selectCondition"
          :features.sync="selectedFeatures"
        >
          <template slot-scope="select">
            <vl-overlay
              v-for="feature in select.features"
              :id="feature.id"
              :key="feature.id"
              class="feature-popup"
              :position="pointOnSurface(feature.geometry)"
              :auto-pan="false"
              :auto-pan-animation="{ duration: 300 }"
              class-name="ol-overlay-container ol-selectable smooth-transition"
              positioning="bottom-right"
            >
              <div style="background: #fff; padding: 10px; width: 200px">
                {{ feature.id }}
              </div>
            </vl-overlay>
          </template>
        </vl-interaction-select>

        <!-- <vl-layer-image id="jz">
        <vl-source-image-static
          :url="imageUrl"
          :size="imageSize"
          :extent="imageExtent"
          :projection="imageProj">
        </vl-source-image-static>
      </vl-layer-image> -->

        <template v-for="site in sites">
          <vl-feature :id="site.site">
            <vl-geom-point :coordinates="[parseFloat(site.location_lon), parseFloat(site.location_lat)]" />
            <template v-if="site.alarm">
              <vl-style-box>
                <vl-style-icon
                  src="https://i.ibb.co/nbtsbjW/marker-red.png"
                  :scale="0.3"
                  :anchor="[0.5, 1]"
                  :size="[180, 180]"
                />
              </vl-style-box>

              <!-- <vl-style-box>
                <vl-style-icon src="https://i.ibb.co/tpfFWvC/marker-orange.png" :scale="0.3" :anchor="[0.5, 1]" :size="[180, 180]"></vl-style-icon>
              </vl-style-box> -->
            </template>

            <template v-else>
              <vl-style-box>
                <vl-style-icon
                  src="https://i.ibb.co/2c2ywX8/marker-green.png"
                  :scale="0.3"
                  :anchor="[0.5, 1]"
                  :size="[180, 180]"
                />
              </vl-style-box>
            </template>
          </vl-feature>
        </template>


        <!--// overlay marker -->

        <!-- <vl-layer-vector id="features" ref="featuresLayer" render-mode="image">
          <vl-source-vector :features.sync="features" ref="featuresSource" />
          <vl-style-func :factory="styleFuncFactory" />
        </vl-layer-vector> -->

        <vl-layer-vector
          v-if="drawType != null"
          id="draw-pane"
        >
          <vl-source-vector
            :features.sync="drawnFeatures"
            ident="draw-target"
          />
        </vl-layer-vector>

        <!-- <vl-interaction-draw :type="drawType" source="draw-target" v-if="drawType != null" /> -->
      </vl-map>
    </div>
  </div>
</template>

<script>
  import { isFunction, range, random, forEach, throttle } from "lodash";
  import * as eventCondition from "ol/events/condition";
  import { inAndOut } from "ol/easing";
  import Feature from "ol/Feature";
  import Point from "ol/geom/Point";
  import { findPointOnSurface, defaultStyle, defaultEditStyle, createStyle, pointFromLonLat } from "../ol-ext";
  import { userService } from "../_services";




  export default {
    data () {
      return {
        type: ["info", "success","warning", "warning", "danger",""],
        notifications: {
          topCenter: false
        },
        oldList: [],
        alarmList: [],
        triggers:[],
        sites:[],
        timer: "",
        features:[],
        zoom: 4.7,
        center: [-49.0287103,-13.9959469],
        rotation: 0,
        features: [],
        featureAnimations: {},
        selectedFeatures: [],
        graticule: false,
        showMap: true,
        drawType: undefined,
        drawnFeatures: [],
        selectByHover: false,
        loading:true

      };
    },
    computed: {
      selectCondition () {
        return eventCondition.pointerMove;
      },
    },
    mounted () {
      this.sites = JSON.parse(localStorage.getItem("sites"));
      // this.loading = false;
      this.loadData();
      // this.timer = setInterval(this.loadData, 5000)
    },
    beforeDestroy () {
      forEach(this.featureAnimations, cancel => cancel());
    },
    methods: {
      pointOnSurface: findPointOnSurface,
      styleFuncFactory () {
        var style = createStyle({fillColor: [255, 0, 0, 0.4], strokeColor: "#CC3333", strokeWidth: 1.25, imageRadius: 5});
        return feature => {
          return [style];
        };
      },
      styleFuncFactoryGreen () {
        var style = createStyle({fillColor: [0, 255, 0, 0.4], strokeColor: "#33CC33", strokeWidth: 1.25, imageRadius: 5});
        return feature => {
          return [style];
        };
      },
      loadData: function () {
        userService.AsingZabbixProblems(this.sites).then(zabbixProblems => {
          this.oldList=this.alarmList;
          this.alarmList = zabbixProblems;

          // console.log(this.alarmList )
          var i=0,j=0,count=0,newAlarm=[];
          for(i=0;i<this.sites.length;i++){
            count=0;
            for(j=0;j<this.alarmList.length;j++){
              // if(this.sites[i].site==this.alarmList[j].site && this.alarmList[j].acknowledged!="SIM"){
                if(this.sites[i].site==this.alarmList[j].site){
                count=count+1;
              }
            }
            if(count>0){
                this.sites[i].alarm=true;
                // console.log("ALARME ATIVO")
            }
            else{
                this.sites[i].alarm=false;

            }
          }
          this.loading = false;
          // console.log(this.sites);
        });
      },
      cancelAutoUpdate: function() { clearInterval(this.timer); }
    }
  };
</script>

<style lang="scss" rel="stylesheet/scss">
  @import "~ol/ol";

  html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    box-sizing: border-box;
    font-family: Helvetica, Arial, sans-serif;

    * {
      box-sizing: border-box;
    }
  }

  .panel {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 70vw;
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0 0 20px rgba(2, 2, 2, 0.1);
    padding: 5px;
    text-align: center;
    z-index: 1;


    > button {
      margin: 5px;
      padding: 5px 10px;
      text-transform: uppercase;
    }
  }

  .smooth-transition {
    transition: all 0.3s ease-in-out;
  }
</style>
